import React from 'react'

import Icon from 'Core/Components/Icon'
import CopyButton from 'Core/Components/CopyButton'

import { keyState, getAssetAttributes, getIconForAsset, assetsViewLayoutTypes, transformAssetList } from './assets-utils'



export const AssetsTableView = ({ assets, selection, onSelectionChange, onSelectDirectory, onFileRename, onFileDelete, onDirectoryDelete, onDirectoryRename }) => {
    return (
        <div style={{ width: '100%', padding: 10 }}>
            <table className="assets-view-table" style={{ width: '100%', fontSize: 13 }}>
                <thead>
                    <tr>
                        <th> </th>
                        <th>Filename</th>
                        <th>URI</th>
                        <th>Type</th>
                        <th>File size</th>
                        {/* <th>Created</th> */}
                        <th>Modified</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {assets.map(asset => {
                        const attributes = getAssetAttributes(asset)
                        const icon = getIconForAsset(asset)
                        const iconComponent = icon === 'file-image-o'
                            ? <img src={asset.uri} style={{ height: 20, maxWidth: 30 }} />
                            : <Icon fa={getIconForAsset(asset)}/>
                        const toggledSelection = selection.includes(asset.uri)
                            ? selection.filter(u => u !== asset.uri)
                            : [...selection, asset.uri]

                        return (
                            <tr
                                key={asset.uri}
                                className={`${selection.includes(asset.uri) ? 'active' : ''}`}
                                onClick={() => keyState.cmdActive || keyState.ctrlActive ? onSelectionChange(toggledSelection) : onSelectionChange([asset.uri])}
                                onDoubleClick={() => asset.type === 'directory' ? onSelectDirectory(asset.uri) : null}>
                                <td style={{ textAlign: 'center' }}>{iconComponent}</td>
                                <td>{asset.name}</td>
                                <td>{asset.uri}</td>
                                <td style={{ textAlign: 'center' }}>{asset.type.toUpperCase()}</td>
                                <td style={{ textAlign: 'center' }}>{attributes[0].value}</td>
                                {/* <td>{attributes[1].value}</td> */}
                                <td style={{ textAlign: 'center' }}>{attributes[2].value}</td>
                                <td>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                        {asset.type === 'directory'
                                            ? (
                                                <React.Fragment>
                                                    <a className="btn btn-calm" onClick={(e) => e.stopPropagation() || setTimeout(() => onSelectDirectory(asset.uri))}>
                                                        <Icon fa="hand-o-right" style={{ float: 'left' }} /> Open
                                                    </a>
                                                    <button className="btn-warn" onClick={(e) => e.stopPropagation() || onDirectoryRename(asset.uri)}>
                                                        <Icon fa="i-cursor" style={{ float: 'left' }} /> Rename
                                                    </button>
                                                    <button className="btn-danger" onClick={(e) => e.stopPropagation() || onDirectoryDelete(asset.uri)}>
                                                        <Icon fa="trash" style={{ float: 'left' }} /> Delete
                                                    </button>
                                                </React.Fragment>
                                            )
                                            : (
                                                <React.Fragment>
                                                    <a className="btn btn-calm" href={asset.uri} target="_blank">
                                                        <Icon fa="external-link" style={{ marginLeft: -7, float: 'left' }} /> Open
                                                    </a>
                                                    <button className="btn-success" onClick={() => navigator.clipboard.writeText(window.location.protocol.concat('//', window.location.host, asset.uri))}>
                                                        <Icon fa="copy" style={{ marginLeft: -7, float: 'left' }} /> Copy URL
                                                    </button>
                                                    <button className="btn-warn" onClick={() => onFileRename(asset.uri)}>
                                                        <Icon fa="i-cursor" style={{ marginLeft: -7, float: 'left' }} /> Rename
                                                    </button>
                                                    <button className="btn-danger" onClick={() => onFileDelete(asset.uri)}>
                                                        <Icon fa="trash" style={{ marginLeft: -7, float: 'left' }} /> Delete
                                                    </button>
                                                </React.Fragment>
                                            )}
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/Assets/AssetsTableView.jsx